module.exports = __webpack_public_path__ + "static/media/vendor.1599eef4.png";